/* PoscART — dismiss the header search on scroll          (2026-09-13)
 * ---------------------------------------------------------------------------
 * Opening the header search adds .header-row__overlay.active and drops the
 * predictive panel under the header. Scrolling the page moved the panel out of
 * view but left the overlay on — the page stayed dimmed and the search stayed
 * open behind it. Close it properly once the reader has scrolled away.
 *
 * Uses the theme's own HeaderSearch.onClose() rather than stripping classes by
 * hand, so focus handling and scroll locking unwind the way the theme expects.
 */
(function () {
  'use strict';

  var CLOSE_AFTER = 140; // px of scroll before the panel is considered abandoned
  var openedAt = null;

  function overlay() {
    return document.querySelector('.header-row__overlay.active');
  }

  function close() {
    var search = document.querySelector('header-search');
    if (search && typeof search.onClose === 'function') {
      try { search.onClose(); } catch (e) { /* fall through to the overlay */ }
    }
    var el = overlay();
    if (el) el.classList.remove('active');
    openedAt = null;
  }

  function onScroll() {
    if (!overlay()) { openedAt = null; return; }
    if (openedAt === null) { openedAt = window.scrollY; return; }
    if (Math.abs(window.scrollY - openedAt) > CLOSE_AFTER) close();
  }

  function watch() {
    var host = document.querySelector('.header-wrapper') || document.body;
    if (!host) return;
    new MutationObserver(function () {
      if (overlay()) {
        if (openedAt === null) openedAt = window.scrollY;
      } else {
        openedAt = null;
      }
    }).observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    watch();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
